// import Button from '@mui/material/Button'
import Employment from "./Employment"
import Education from "./Education"
import Publications from "./Publications"
import { useTheme } from '@mui/material/styles'
import { useMediaQuery } from '@mui/material'


function App() {
  const theme = useTheme()
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('lg'))
  const isPastMax = useMediaQuery(theme.breakpoints.up('xl'))

  return (

    <section
      style={{
        display: 'flex',
        flexDirection: 'column',
        columnGap: '40px',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <header
        id="Name"
        style={{
          padding: '40px 0px 100px',
          width: '100%',
          maxWidth: '1440px'
        }}
      >
        <h1 style={{ padding: isPastMax ? '0' : '0 40px', color: theme.palette.main }}>
          Dorin
          <br />
          Manase
          <span style={{ fontFamily: 'Lato', color: theme.palette.grey }}>
            .
          </span>
        </h1>
      </header>

      {/* Body */}
      <section
        style={{
          padding: '0 40px 80px',
          display: 'flex',
          columnGap: '100px',
          rowGap: '100px',
          flex: '1 1 100%',
          maxWidth: '1440px',
          ...isMediumScreen && { flexWrap: 'wrap', },
        }}
      >
        {/* About aside */}
        <aside
          style={{
            maxWidth: isLargeScreen ? '324px' : '100%',
            borderTop: '1px solid ' + theme.palette.lightGrey
          }}
        >
          <h2
            style={{
              color: theme.palette.darkGrey,
              paddingBottom: '40px'
            }}
          >
            About
          </h2>
          <p style={{ color: theme.palette.darkGrey }}>
            Currently with the Data Aggregation, Translation, and Architecture (DATA)
            team within the University Health Network, working as a senior manager
            specializing in the use of artificial intelligence and advanced software
            development approaches to help clinicians streamline and improve patient care.
          </p>
        </aside>

        {/* Main Content */}
        <section
          style={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            rowGap: '28px'
          }}
        >
          <Employment />
          <Education />
          <Publications />
        </section>

      </section>
    </section>
  )
}

export default App
